export interface ParsedCitationRoute {
  path: string;
  queryParams: Record<string, string>;
}

export function parseCitationRoute(route: string | null | undefined): ParsedCitationRoute {
  if (!route) {
    return { path: '', queryParams: {} };
  }

  const queryIndex = route.indexOf('?');
  if (queryIndex === -1) {
    return { path: route, queryParams: {} };
  }

  const path = route.slice(0, queryIndex);
  const queryString = route.slice(queryIndex + 1);
  const queryParams: Record<string, string> = {};
  new URLSearchParams(queryString).forEach((value, key) => {
    queryParams[key] = value;
  });

  return { path, queryParams };
}
